import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-button_icon-34",
  "use": "icon-button_icon-34-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-button_icon-34\"><g stroke=\"currentColor\" fill=\"transparent\"><path stroke-width=\"1.5\" d=\"M2.75 2.75h7.5v7.5h-7.5zM13.75 2.75h7.5v7.5h-7.5zM2.75 13.75h7.5v7.5h-7.5z\" /><path stroke-width=\"1.5\" stroke-linecap=\"square\" d=\"M14 21.27v-7.478h3.5V17.5H21v-3.708\" /><path d=\"M6 6h1v1H6zM17 6h1v1h-1zM6 17h1v1H6z\" /><path stroke-width=\"1.5\" stroke-linecap=\"square\" d=\"M17.5 21.271H21\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol